import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import analytics from "web/script/analytics/analytics";
import CookieSettings from "web/react/components/cookie-settings/cookie-settings";
import withReduxProvider from "web/react/redux-provider";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { closeOverlay } from "web/redux/ducks/cookie-settings";

function extractState(state) {
  return state.cookieSettingsReducer.overlayIsOpen;
}

function CookieSettingsContainer(_ref) {
  var isOpen = _ref.isOpen,
      onModalClose = _ref.onModalClose;
  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      defaultIsOpen = _useState2[0],
      setDefaultIsOpen = _useState2[1];

  var settingsOverlayIsOpen = useReduxSelector(extractState);
  useEffect(function () {
    setDefaultIsOpen(settingsOverlayIsOpen);
  }, [settingsOverlayIsOpen]);

  function defaultOnClose() {
    dispatch(closeOverlay());
    setDefaultIsOpen(false);
  }

  var eventLabel;
  var cookieSettingsProps;

  if (typeof isOpen === "boolean" && onModalClose) {
    eventLabel = "banner";
    cookieSettingsProps = {
      isOpen: isOpen,
      onModalClose: onModalClose
    };
  } else {
    eventLabel = "footer";
    cookieSettingsProps = {
      isOpen: defaultIsOpen,
      onModalClose: defaultOnClose
    };
  }

  useEffect(function () {
    if (cookieSettingsProps.isOpen) {
      analytics.event("cookie_settings", "shown", eventLabel);
    }
  }, [cookieSettingsProps.isOpen, eventLabel]);
  return React.createElement(CookieSettings, cookieSettingsProps);
}

export default withReduxProvider(CookieSettingsContainer);